"use client";

import {CheckboxProps, Checkbox as RACCheckbox} from "react-aria-components";
import clsMerge from "../../util/clsMerge";
import {ForwardedRef, forwardRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/sharp-solid-svg-icons/faCheck";

const Checkbox = (
	props: CheckboxProps,
	ref: ForwardedRef<HTMLLabelElement>
) => {
	const {children, className, ...checkboxProps} = props;
	return (
		<RACCheckbox
			className={clsMerge("flex cursor-pointer flex-row gap-2", className)}
			ref={ref}
			{...checkboxProps}
		>
			{({isSelected, isDisabled, isInvalid, isFocused}) => {
				return (
					<>
						<div
							className={clsMerge(
								"checkbox mt-[0.08rem] h-5 py-0.5 text-gray-800",
								isDisabled && "text-gray-600",
								isInvalid && "text-rich-orange"
							)}
						>
							<svg
								className={clsMerge(
									"h-full",
									isFocused && "ring ring-navy-200"
								)}
								viewBox="0 0 18 18"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<rect
									x="0.5"
									y="0.5"
									width="17"
									height="17"
									rx="2.5"
									fill={isDisabled ? "#e5e3dc" : "white"}
									stroke="currentColor"
								/>
								{isSelected && (
									<FontAwesomeIcon
										icon={faCheck}
										transform="shrink-3"
										color="currentColor"
									/>
								)}
							</svg>
						</div>
						{children}
					</>
				);
			}}
		</RACCheckbox>
	);
};

export default forwardRef<HTMLLabelElement, CheckboxProps>(Checkbox);
